import { Component, Input, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { LookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-company-contact-picker',
  standalone: true,
  imports: [
    FormsModule,
    AutoCompleteModule,
  ],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyContactPickerComponent),
      multi: true
    }
  ]
})
export class CompanyContactPickerComponent extends BasePickerComponent<LookupItem> {
  @Input() companyId: string = '';
  @Input() role: number | undefined = undefined;
  @Input() displayRole: boolean = false;

  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<LookupItem>> {
    return this.lookupService.getCompanyContacts(undefined, query, this.companyId, this.role, 20);
  }

  override load(keys: string[]): Observable<ListResult<any>> {
    return this.lookupService.getCompanyContacts(keys);
  }

  override format(items: LookupItem[]): LookupItem[] {
    return items.map(item => {
      if (this.displayRole && item.role) {
        return {
          ...item,
          title: `${item.title} ${item.role}`
        };
      }
      return item;
    });
  }
}
